import Tree from 'rc-tree'
import './TreeWidget.scss'
import type { RefObject, VFC } from 'react'
import type { TreeProps } from 'rc-tree'

export interface TreeWidgetProps extends TreeProps {
  treeRef: RefObject<any> | undefined
}

export const TreeWidget: VFC<TreeWidgetProps> = (props) => {
  return (
    <Tree
      {...props}
      ref={props.treeRef}
      prefixCls='spk-rc-tree'
    />
  )
}
